const PromoCodeTemplateIndex = () => import("@/views/other/promoCodeTemplate/PromoCodeTemplateIndex.vue")

const moduleBasePath = "/admin/promo-code-template/"

const routes = [
    {
        path: `${moduleBasePath}`,
        name: "PromoCodeTemplateIndex",
        component: PromoCodeTemplateIndex,
        meta: {
            label: "Promo Code Templates"
        }
    }
]

export default routes
